import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getApi } from '../../../Services/apiService';

const UserPetDetail = () => {
    const { userId, petId } = useParams();
    const navigate = useNavigate();
    const [pet, setPet] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPet = async () => {
            if (!petId) return;
            setLoading(true);
            setError(null);
            try {
                const response = await getApi(`/api/v1/admin/pets/${petId}`);
                const data = response?.data ?? response;
                setPet(data);
            } catch (err) {
                console.error('Error fetching pet details:', err);
                setError('Failed to load pet details.');
                setPet(null);
            } finally {
                setLoading(false);
            }
        };
        fetchPet();
    }, [petId]);

    const handleBackToUser = () => {
        navigate(`/admin/users/${userId}`);
    };

    if (loading) {
        return (
            <div className="RightSideDiv">
                <div style={{ padding: '60px 20px', textAlign: 'center' }}>
                    <p>Loading pet details...</p>
                </div>
            </div>
        );
    }

    if (error || !pet) {
        return (
            <div className="RightSideDiv">
                <div style={{ padding: '60px 20px', textAlign: 'center' }}>
                    <p>{error || 'Pet not found.'}</p>
                    <button type="button" className="add-shelter-btn" style={{ marginTop: 16 }} onClick={handleBackToUser}>
                        Back to User Detail
                    </button>
                </div>
            </div>
        );
    }

    const name = pet.petName ?? pet.name ?? 'Pet';
    const imageSrc = pet.image ?? pet.photo ?? pet.profileImage ?? pet.petImage;
    const safetyScore = pet.safetyScore ?? pet.safety_score ?? pet.safetyScorePercent;
    const earnedBadges = Array.isArray(pet.earnedBadges)
        ? pet.earnedBadges
        : pet.badge
            ? [{ name: pet.badge, icon: 'safety' }]
            : [];

    const attributes = [
        { label: 'Gender', value: pet.gender },
        { label: 'Species', value: pet.species },
        { label: 'Breed', value: pet.breed },
        { label: 'Age', value: pet.age ? (String(pet.age).includes('yr') ? pet.age : `${pet.age} yrs old`) : null },
        { label: 'Weight', value: pet.weight ? `${pet.weight} kg` : null },
        { label: 'Color', value: pet.color },
        { label: 'Personality', value: pet.personality },
        { label: 'Marking/Pattern', value: pet.markingPattern ?? pet.marking ?? pet.pattern },
        { label: 'Microchip number', value: pet.microchipNumber ?? pet.microchip },
        { label: 'Is pet sterilized', value: pet.isSterilized != null ? (pet.isSterilized ? 'Yes' : 'No') : (pet.sterilized != null ? (pet.sterilized ? 'Yes' : 'No') : null) },
        { label: 'Activity level', value: pet.activityLevel ?? pet.activity },
        { label: 'Coat type', value: pet.coatType ?? pet.coat },
        { label: 'Lifestyle', value: pet.lifestyle },
    ];

    return (
        <div className="RightSideDiv">
            {/* <nav className="user-detail-breadcrumb">
                <button type="button" className="breadcrumb-link" onClick={() => navigate('/admin/users')}>
                    User management
                </button>
                <span className="breadcrumb-sep"> &gt; </span>
                <button type="button" className="breadcrumb-link" onClick={handleBackToUser}>
                    User Detail
                </button>
            </nav>
            <p className="user-detail-overview">Overview</p> */}

            <div className="user-pet-detail-layout">
                <div className="user-pet-detail-card">
                    <div className="user-pet-detail-image-wrap">
                        <img
                            src={imageSrc?.startsWith?.('http') ? imageSrc : (imageSrc ? window.getPublicUrl(imageSrc) : window.getPublicUrl('/assets/images/dummy-profile.jpg'))}
                            alt={name}
                            className="user-pet-detail-image"
                            onError={(e) => { e.target.src = window.getPublicUrl('/assets/images/dummy-profile.jpg'); }}
                        />
                    </div>
                    <div className="user-pet-detail-header">
                        <h2 className="user-pet-detail-name">{name}</h2>
                        {safetyScore != null && (
                            <span className="user-pet-detail-safety-badge">
                                Safety score: {typeof safetyScore === 'number' ? `${safetyScore}%` : safetyScore}
                            </span>
                        )}
                    </div>
                    <div className="user-pet-detail-attributes">
                        {attributes.map(({ label, value }) => (
                            <div key={label} className="pet-detail-attr-row">
                                <span className="pet-detail-attr-label">{label}</span>
                                <span className="pet-detail-attr-value">{value ?? '-'}</span>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="user-pet-earned-badges-card">
                    <h3 className="user-pet-earned-badges-title">Earned Badges</h3>
                    {earnedBadges.length === 0 ? (
                        <p className="user-pet-no-badges">No badges earned yet.</p>
                    ) : (
                        <div className="user-pet-earned-badges-list">
                            {earnedBadges.map((badge, idx) => (
                                <span key={idx} className="user-pet-badge-safety">
                                    <span className="user-pet-badge-icon" aria-hidden>
                                        <img src={window.getPublicUrl('/assets/images/safty.svg')} alt="" />
                                    </span>
                                    {badge.name ?? badge}
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserPetDetail;
